import apiTool from './index';

const GET_CATEGORIES_URL = 'exchange/get-categories/';
const ADD_CATEGORY_URL = 'exchange/add-category/';
const UPDATE_CATEGORY_URL = 'exchange/update-category/';
const DELETE_CATEGORY_URL = 'exchange/delete-category/';
const GET_FORUMARTICLES_URL = 'exchange/get-articles/';
const GET_FORUMARTICLE_URL = 'exchange/get-article/';
const ADD_FORUMARTICLE_URL = 'exchange/add-article/';
const ADD_COMMENT_URL = 'exchange/add-comment/';
const SEND_COACHING_URL = 'exchange/coaching/';
const GET_NEWS_URL = 'exchange/get-news/';
const ADD_NEWS_URL = 'exchange/add-news/';
const GET_PRIORITY_NEWS_URL = 'exchange/get-priority-news/';

export default {
    getPriorityNews() {
        return apiTool.get(GET_PRIORITY_NEWS_URL);
    },
    getNews(payload) {
        return apiTool.get(GET_NEWS_URL);
    },
    addNews(payload) {
        return apiTool.post(ADD_NEWS_URL, payload);
    },
    getCategories(payload) {
        return apiTool.get(GET_CATEGORIES_URL);
    },
    addCategory(payload) {
        return apiTool.post(ADD_CATEGORY_URL, payload);
    },
    addForumArticle(payload) {
        return apiTool.post(ADD_FORUMARTICLE_URL, payload);
    },
    getForumArticles(category_id) {
        return apiTool.get(GET_FORUMARTICLES_URL + category_id + '/');
    },
    getForumArticle(article_id) {
        return apiTool.get(GET_FORUMARTICLE_URL + article_id + '/');
    },
    updateCategory(payload) {
        return apiTool.post(UPDATE_CATEGORY_URL + payload.id + '/', payload);
    },
    deleteCategory(category_id) {
        return apiTool.delete(DELETE_CATEGORY_URL + category_id + '/');
    },
    addComment(payload) {
        return apiTool.post(ADD_COMMENT_URL, payload);
    },
    sendCoaching(payload) {
        return apiTool.post(SEND_COACHING_URL, payload);
    },
}
